<template>
  <div>
    <b-card>
      <titleSection
        title="Calendario"
        subtitle="Fechas programadas en un periodo"
        icon="CalendarIcon"
      />
    </b-card>

    <b-row>
      <b-col
        cols="12"
        md="4"
      >
        <b-card>
          <div class="text-center">
            <!-- Selector de periodo -->
            <b-overlay
              :show="loader.periodo"
              opacity="0.50"
              rounded="sm"
            >
              <b-dropdown
                :text="`Periodo ${periodoSelected}`"
                size="sm"
                class="budget-dropdown"
                variant="primary"
              >
                <b-dropdown-item
                  v-for="per in periodos"
                  :key="per.periodo"
                  @click="periodoSelected = per.clave; getScheadule(per.periodo)"
                >
                  {{ per.clave }}
                </b-dropdown-item>
              </b-dropdown>
            </b-overlay>
            <!-- Tipos de eventos -->
            <b-overlay
              :show="loader.calendario"
              opacity="0.50"
              rounded="sm"
            >
              <b-list-group class="list-group-labels text-left mt-1">
                <b-list-group-item
                  v-for="type in tipos"
                  :key="type.id"
                  :style="tipoSelected.id === type.id ? `border-left: 3px solid #${type.color}; cursor: default;` : 'cursor: pointer;'"
                  @click="tipoSelected.id === type.id ? tipoSelected = {} : tipoSelected = type"
                >
                  <span
                    class="bullet bullet-sm mr-1"
                    :style="`background-color: #${type.color};`"
                  />
                  <span :class="{'font-weight-bolder': tipoSelected.id === type.id}">{{ type.nombre }}</span>
                </b-list-group-item>
              </b-list-group>
            </b-overlay>
          </div>
        </b-card>
      </b-col>
      <!-- Eventos de calendario -->
      <b-col
        cols="12"
        md="8"
      >
        <div class="col position-relative">
          <b-overlay
            :show="loader.calendario"
            opacity="0.50"
            rounded="sm"
          >
            <div class="card shadow-none border-0 mb-0 rounded-0">
              <div class="card-body">
                <app-timeline v-if="calendario.length">
                  <app-timeline-item
                    v-for="cal in filteredScheadule"
                    :key="`${cal.id}-${cal.fecha}`"
                    :title="cal.evento"
                    :subtitle="cal.descripcion"
                    :time="timestampToDate(cal.fecha)"
                    :rgb-color="`#${cal.color}`"
                  />
                </app-timeline>
                <div
                  v-else
                  class="text-center text-muted m-1"
                >
                  <small>No hay eventos en el calendario</small>
                </div>
              </div>
            </div>
          </b-overlay>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BDropdown,
  BDropdownItem,
  BListGroup,
  BListGroupItem,
  BOverlay,
} from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import { useRouter } from '@core/utils/utils'
import { timestampToDate } from '@core/utils/filter'
import {
  computed,
  onMounted, ref,
} from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import titleSection from '@/views/components/title-section.vue'
import { periodsFromPlan, periodScheadule } from '@/views/public/oferta-academica/useDetalleOferta'

export default {
  components: {
    titleSection,
    BCard,
    AppTimeline,
    AppTimelineItem,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BListGroup,
    BListGroupItem,
    BOverlay,
  },
  setup() {
    const toast = useToast()
    const { route } = useRouter() //* Use router propieties
    const { id } = route.value.params //* Get the token from params
    const loader = ref({ periodo: false, calendario: false })
    const periodos = ref([]) //* Arreglo de periodos
    const periodoSelected = ref(null) //* Periodo seleccionado
    const tipos = ref([]) //* Arreglo de tipos por periodo
    const tipoSelected = ref({}) //* Tipo seleccionado
    const calendario = ref([]) //* Calendario

    //* Load period's scheadule
    const getScheadule = periodo => {
      tipoSelected.value = {}
      loader.value.calendario = true
      periodScheadule(periodo).then(response => {
        loader.value.calendario = false
        tipos.value = response.tipo
        calendario.value = response.calendario
      }, error => {
        tipos.value = []
        calendario.value = []
        loader.value.calendario = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición [Calendario de periodo]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      })
    }

    //* Load available periodos
    const loadPeriodos = () => {
      loader.value.periodo = true
      periodsFromPlan(id).then(response => {
        loader.value.periodo = false
        periodos.value = response
        periodoSelected.value = response[response.length - 1].clave
        getScheadule(response[response.length - 1].periodo)
      }, error => {
        loader.value.periodo = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición [Información de materia]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      })
    }

    //* Filter scheadule from type selected
    const filteredScheadule = computed(() => {
      if (!tipoSelected.value.id) return calendario.value
      return calendario.value.filter(item => item.tipo === tipoSelected.value.id)
    })

    onMounted(() => {
      if (!Number.isNaN(id) && id !== undefined) loadPeriodos()
    })

    return {
      // Variables
      periodos,
      periodoSelected,
      calendario,
      tipos,
      tipoSelected,
      // Methods
      getScheadule,
      // Computed
      filteredScheadule,
      // Filters
      timestampToDate,
      // Loader
      loader,
    }
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/apps/calendar.scss";
</style>
